import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import 'react-infinite-calendar/styles.css'; // Make sure to import the default stylesheet
import $ from 'jquery';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css'
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Pagination from "react-js-pagination";
var datestring = moment().format('YYYY-MM');
class RevenueReseller extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            curr_month: datestring,
            str_month: [],
            customer_details: '',
            subscription_list: [],
            searchsubscription: '',
            isLoadMore: 1,
            activePage: 1,
            loading: 1,
            item_count: '',
            fields: {},
            errors: {},
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
        };
        this.searchChange = this.searchChange.bind(this);
        this.onMonthChange = this.onMonthChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    onMonthChange(event) {
        this.setState({
            curr_month: event.target.value, activePage: 1,
            subscription_list: [],
            loading: 1,
        }, function () {
            this.SubscriptionList();
        });
    }
    searchChange(event) {
        var obj = this;
        this.setState({ searchsubscription: event.target.value, activePage: 1,subscription_list: [],loading: 1});
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
    }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.SubscriptionList();
        }, 500);
    }
    customer_details(id) {
        fetch(this.state.apiUrl + '/RevenueRest/getPartnerCustomerRevenue/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    customer_details: findresponse.customer_details,
                    count: findresponse.items_count,
                })
            })
    }

    getSubscriptionDetails() {
        if (this.state.loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        }
        else {
            return (
                <div class="list_check">
                    <div class="tickets hidden-sm">
                        <ul class="tickets_head adv">
                            <li class="intra_col_20">Reseller Name</li>
                            <li class="intra_col_15">Package</li>
                            <li class="intra_col_15">Payment Date</li>
                            <li class="intra_col_15">Amount</li>
                            <li class="intra_col_10">Method</li>
                            <li class="intra_col_20">Next Payment Date</li>
                            <li class="intra_col_5">Action</li>
                        </ul>
                        {
                            this.state.subscription_list.map((subscription, key) =>
                                <ul class="tickets_number" >
                                    <li class="intra_col_20">{subscription.name ? subscription.name : ''}</li>
                                    <li class="intra_col_15">{subscription.packeg ? <span>{subscription.packeg + ', '}<i class="text-primary">{subscription.plans}</i></span> : ''}</li>
                                    <li class="intra_col_15">{subscription.last_trns_dt ? subscription.last_trns_dt : ''}</li>
                                    <li class="intra_col_15">{subscription.reseller == 'sony' ? '$' + subscription.billing_amount : '$' + subscription.charge_amount}</li>
                                    <li class="intra_col_10">{subscription.payment_method == 1 ? 'Credit card' : (subscription.payment_method == 2) ? 'Wire Transfer' : 'Pay by Paypal'}</li>
                                    <li class="intra_col_20">{subscription.start_date ? subscription.start_date : ''}</li>
                                    <li class="intra_col_5 ">
                                        <div class="edit_delete">
                                            <span class="icon tooltips" onClick={() => this.customer_details(subscription.id)} data-toggle="modal" data-target={"#customerDetailsModal"}><a href="javascript:void(0);"><i class="far fa-user-circle"></i></a><span class="tooltiptext">Customer Details</span></span>
                                        </div>
                                    </li>
                                </ul>
                            )
                        }
                    </div>
                    <div class="custmer_mob hidden-md">
                        {
                            this.state.subscription_list.map((subscription, key) =>

                                <div class="custmer_list_mob">
                                    <h4 class="list_title">{subscription.name}</h4>
                                    <h6>{subscription.packeg}</h6>
                                    <div tabindex="0" class="onclick-menu pull-right">
                                        <span onClick={() => this.customer_details(subscription.id)} data-toggle="modal" data-target={"#customerDetailsModal"}><a href="javascript:void(0);"><i class="far fa-user-circle"></i></a></span>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}
                </div>
            )
        }
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/RevenueRest/resellerList/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.subscription_list.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    subscription_list: this.state.subscription_list.concat(findresponse.subscription_list),
                })
            })
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/RevenueRest/resellerList/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        subscription_list: findresponse.subscription_list,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }

    SubscriptionList(page = 1) {
        fetch(this.state.apiUrl + '/RevenueRest/resellerList/page/' + page + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    subscription_list: findresponse.subscription_list,
                    item_count: findresponse.item_count,
                    loading: 0,
                    hidden_column: findresponse.hidden_column,
                    quick_stats: findresponse.quick_stats,
                    projected_revenue: findresponse.projected_revenue,
                    str_month: findresponse.str_month,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }

    componentDidMount() {
        document.title = "Intranet | Revenue Reseller";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        this.SubscriptionList();
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Reseller" brecum_page="Resellers" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="top-row margin_0 hidden-xs">
                            <div className="left-section pull-left">
                                <div class="title mob hidden-sm border_less">
                                    <span>Subscription</span>
                                </div>
                            </div>
                            <div className="right-section">
                                <div className="row">
                                    <div className="col-md-6 col-xs-12">
                                        <div class="searchTicket mob_customer">
                                            <div className="filter">
                                                <select value={this.state.curr_month} class="form-control" onChange={this.onMonthChange}>
                                                    <option value="">All Months</option>
                                                    {
                                                        this.state.str_month.map((value, key) =>
                                                            <option value={value.id}>{value.name}</option>
                                                        )
                                                    }
                                                </select>
                                                <i class="fal fa-angle-down"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-xs-12">
                                        <div class="searchTicket mob_customer">
                                            <input type="text" class="form-control" id="searchsubscription" name="searchsubscription" placeholder="Search By Name" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-content customer-tab clearfix">
                            <div class="tab-pane active" id="Subscription">

                                {/* <--modal start for Customer Details-!> */}
                                <div class="modal fade" id={"customerDetailsModal"} role="dialog">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <div class="modal-body clearfix" style={{ maxHeight: "500px", overflowY: 'auto' }}>
                                                <div class="col-sm-12">
                                                    <div >
                                                        <ul class="tickets_head adv">
                                                            <li class="intra_col_20">Name</li>
                                                            <li class="intra_col_20">Website</li>
                                                            <li class="intra_col_20">Package</li>
                                                            <li class="intra_col_20">Platform Fee</li>
                                                            <li class="intra_col_20">Customer Since</li>
                                                        </ul>
                                                        {this.state.customer_details != '' && this.state.count == 1 ? <ul class="tickets_number">
                                                            <li class="intra_col_20">{this.state.customer_details.name}</li>
                                                            <li class="intra_col_20">{this.state.customer_details.domain}</li>
                                                            <li class="intra_col_20">{this.state.customer_details.package}<br />{this.state.customer_details.app}<br />Plan : {this.state.customer_details.plan != 'N/A' ? this.state.customer_details.plan + 'ly' : this.state.customer_details.plan}</li>
                                                            <li class="intra_col_20">{this.state.customer_details.base_price}</li>
                                                            <li class="intra_col_20">{this.state.customer_details.start_date}</li>
                                                        </ul> : <ul class="tickets_number">
                                                                <li class="intra_col_20">No data found</li>

                                                            </ul>}

                                                    </div>
                                                </div>

                                            </div>

                                            <div class="modal-footer" style={{ borderTop: '0px' }}>
                                                <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <--modal end for Customer Details-!> */}
                                {this.getSubscriptionDetails()}
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        )
    }

}
export default RevenueReseller;



// WEBPACK FOOTER //
// ./src/components/revenue/RevenueReseller.js